import dayjs from '@/init/dayjs';
import { service_RequestCalender } from '@/init/swagger';
import { IsCalendarOr } from '@/schemas/SearchStationDetailSchema';
import { CALENDAR_WEEKS_TYPE, getCalendarWeekText } from '@/types/types';

export const getSearchStationCalendarFilterConditionText = ({
  isCalendarOr,
  calendars,
}: {
  isCalendarOr: IsCalendarOr;
  calendars: service_RequestCalender[];
}) => {
  if (!calendars.length) {
    return '';
  }

  const weekAndZones: string[] = calendars
    .filter((calendar) => {
      return calendar.weeks && calendar.weeks.length;
    })
    .flatMap((calendar) => {
      return calendar.weeks.map((week) => {
        const weekText: string = getCalendarWeekText(
          week as CALENDAR_WEEKS_TYPE,
        );

        return `${weekText}${calendar.zone_start}~${calendar.zone_end}`;
      }) as string[];
    });
  let weekAndZoneText: string = weekAndZones.slice(0, 2).join(', ');
  const remainingCount: number = weekAndZones.length - 2;
  if (remainingCount > 0) {
    weekAndZoneText = weekAndZoneText.concat(`, ...他${remainingCount}`);
  }

  const isCalendarOrText: string = isCalendarOr === 0 ? '全て' : 'いずれか';

  const dateStartText: string = dayjs(calendars[0].date_start).format('M/D');
  const dateEndText: string = dayjs(calendars[0].date_end).format('M/D');
  const dateStartEndText: string = `${dateStartText}~${dateEndText}`;

  return `${weekAndZoneText}, ${isCalendarOrText}, ${dateStartEndText}`;
};
